<template>
  <div>

    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      offset-y
      class="bookingList"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          :disabled="!bookingsList.length"
        >
          <v-icon>tap_and_play</v-icon>
        </v-btn>

      </template>

    <div class="bookingList">
    <v-row justify="center">
      <v-expansion-panels ref="bookingList" flat v-model="expanded">
        <v-expansion-panel v-for="(bookingMsg, i) in bookingsList" :key="i" class="bookingList-item">
          <v-expansion-panel-header>
            <span class="text-caption" style="max-width: 170px">
              <div>{{ bookingMsg.endtime }}</div>
              <div>{{ bookingMsg.id }} &#8680; {{ bookingMsg.driverId | driverName(drivers) }} </div>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content >
            <div class="booking-list-container">

              <div class="booking-list-wrapper">
                <div class="b-date ">{{ bookingMsg.bookings[0].date }} <span> {{ bookingMsg.bookings[0].picktime }}</span></div>
                <div class="b-detail text-center">
                  <div class="b-price">{{ bookingMsg.price | currency}}</div>
                  <div class="px-2 text-left text-caption">
                    <div><span>{{ bookingMsg.bookings[0].trip.origin }}</span></div>
                     <v-divider class="devider-grey my-1"></v-divider>
                    <div><span>{{ bookingMsg.bookings[0].trip.destination}}</span></div>
                  </div>
                </div>
                <div v-if="bookingMsg.bookings[1]" class="b-detail text-center mt-1">
                  <div class="b-retour mt-2 px-2 text-center text-caption">
                    <v-divider class="devider-grey mb-2"></v-divider>
                    Retour: <span class="primary--text"> <strong>{{ bookingMsg.bookings[1].picktime}}</strong></span>
                  </div>
                </div>
              </div>

            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    </div>
    </v-menu>
  </div>
</template>
<script>
import { database } from '@/services/firebase'
export default {
  data () {
    return {
      bookingsList: [],
      expanded: [],
      singleExpand: true,
      menu: null,
      myloop: null,
      headers: [
        { text: 'leftTime', value: 'leftTime' },
        {
          text: 'Date',
          align: 'start',
          sortable: false,
          value: 'timestamp',
        },
        { text: 'picktime', value: 'picktime' },
        { text: 'id', value: 'id' },
        { text: '', value: 'data-table-expand' }
      ],
      dbref: database.ref('bookings/demands')
    }
  },
  methods: {
    init () {
      var app = this;
      database.ref('bookings/demands')
        .orderByChild('/endtime')
        .on('value', event => {
            let items = [];
            event.forEach(data => {
              var booking = data.val();
              booking.key = data.key;
              booking.timer = 99;
              booking.timeLeft = '';
              items.push(booking)
            })
            app.bookingsList = items;
            // console.log('---------------------------- FIREBASE event accepted');
            // console.log('------------------ SET_bookingsList firebase database onUPDATE');
        });
    }
  },
  computed: {
    drivers: {
      cache: false,
      get () {
        return this.$store.getters.drivers;
      }
    }
  },
  filters: {
    driverName(id, drivers) {
      var d = drivers.find((obj) => obj.id === id)
      if(!d) return 'Driver not found';

      return d.lastname + ' ' + d.firstname;
    }
  },
  created () {
    this.init();
  }
}
</script>
<style lang="scss">
.bookingList {
  background: #FFF;
  .bookingList-item {
    border-bottom: solid 1px rgba($color: #ccc, $alpha: .3);
  }
  .v-expansion-panel-header {
    min-height: 32px;
    padding: 10px 24px;
  }
  .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: 32px;
  }
  .booking-list-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .booking-list-wrapper{
      height: 100%;
      max-width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border: solid 1px rgba($color: #ccc, $alpha: .5);
      border-radius: 4px;
      margin: 10px 20px;
      padding: 10px;
      align-items: center;
      .devider-grey {
        color: rgba($color: #ccc, $alpha: .3);
      }
      .b-date {
        padding: 10px 0;
        font-size: 22px;
      }
      .b-retour {
        width: 100%;
      }
      .b-detail {
        width: 90%;
        font-size: 15px;
        display: flex;
        .b-price {
          white-space: nowrap;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          padding: 10px;
          border-right: solid 1px rgba($color: #ccc, $alpha: .3);
        }
      }

    }
    .b-actions {
      width: 100%;
      align-items: center;
      display: flex;
      padding: 18px;
      .v-btn {
        width: 40%;
      }
    }
  }
}
</style>
